/* src/app/modules/search/shared/components/summarize-chat/summarize-chat.component.scss */
.summarize-chat-container {
  display: flex;
  border-radius: 0.5rem;
  position: relative;
  overflow: hidden;
  margin: 1px;
  padding: 4px;
}
.summarize-chat-container .search-chat-history {
  width: 0;
  overflow: hidden;
  background: var(--surface-50);
  transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1), overflow 0.2s ease-in-out;
}
.summarize-chat-container .show-history {
  width: 14rem;
}
.summarize-chat-container .summarize-body-chat {
  max-height: 30rem;
  overflow-y: auto;
}
.summarize-chat-container .summarize-body-chat .message-container {
  display: flex;
  flex-direction: column;
  margin: 0.5rem;
}
.summarize-chat-container .summarize-body-chat .message-container .message {
  width: 80%;
  border-radius: 0.5rem;
  padding: 0.5rem;
  font-size: 0.8rem;
  overflow: hidden;
}
.summarize-chat-container .summarize-body-chat .message-container .user-message {
  align-self: flex-end;
  background: var(--primary-100);
}
.summarize-chat-container .summarize-body-chat .message-container .assistant-message {
  align-self: flex-start;
  background: var(--assistant-100);
}
.summarize-chat-container .prompt-input .prompt-send {
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  cursor: pointer;
  transform: rotate(45deg);
}
.summarize-chat-container .prompt-input .prompt-active ::ng-deep .pi-send {
  color: var(--primary-500);
}
.summarize-chat-container ::ng-deep .p-accordion-tab {
  box-shadow: none !important;
}
.summarize-chat-container ::ng-deep .p-accordion-header-link {
  padding: 0.5rem 1rem !important;
}
.summarize-chat-container .message-actions-div {
  position: absolute;
  bottom: 5px;
  right: 4px;
}
.summarize-chat-container .message-actions-div ::ng-deep .material-symbols-outlined:hover {
  color: var(--assistant-500) !important;
}
@keyframes rotate {
  100% {
    transform: rotate(1turn);
  }
}
.initialize-chat {
  position: relative;
  z-index: 0;
  overflow: hidden;
}
.initialize-chat::before {
  content: "";
  position: absolute;
  z-index: -2;
  background-color: var(--primary-500);
  background-repeat: no-repeat;
  background-size: 50% 50%, 50% 50%;
  background-position:
    0 0,
    100% 0,
    100% 100%,
    0 100%;
  animation: rotate 4s linear infinite;
  left: -50rem;
  width: calc(100% + 100rem);
  height: calc(100% + 150rem);
  top: -75rem;
  background-image:
    linear-gradient(var(--assistant-500), var(--assistant-500)),
    linear-gradient(var(--assistant-500), var(--assistant-500)),
    linear-gradient(var(--primary-500), var(--primary-500)),
    linear-gradient(var(--primary-500), var(--primary-500));
  transform-origin: center;
}
.initialize-chat::after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 3px;
  top: 3px;
  width: calc(100% - 0.4rem);
  height: calc(100% - 0.4rem);
  background: white;
  border-radius: 0.4rem;
}
.subject {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 35rem;
  white-space: nowrap;
}
.disclaimer {
  position: absolute;
  font-size: xx-small;
  width: 100%;
  bottom: 0.2rem;
}
/*# sourceMappingURL=summarize-chat.component.css.map */
